<template>
    <v-container grid-list-sm text-xs-left mt-4>
        <v-layout row wrap justify-left fill-height>
            <v-flex xs12>
                <v-tabs
                        v-model="selectedChallengeTab"
                        color="transparent"
                        slider-color="primary"
                        centered
                >
                    <v-tab
                            v-for="challengeTab in challengeTabs"
                            :key="challengeTab.id"
                            ripple
                    >
                        <strong>{{ challengeTab.name }}</strong>
                    </v-tab>
                    <v-tab-item
                            :key="challengeTabs[0].id"
                            class="my-2"
                    >
                        <ChallengeHomePage/>
                    </v-tab-item>

                    <v-tab-item
                            :key="challengeTabs[1].id"
                            class="my-2"
                    >
                        <ChallengeHomePage
                                published
                        />

                    </v-tab-item>

                    <v-tab-item
                            :key="challengeTabs[2].id"
                            class="my-2"
                    >
                        <ChallengeHomePage
                                published
                                expired
                        />

                    </v-tab-item>
                </v-tabs>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import ChallengeHomePage from "@/pages/Admin/Innovation/ChallengeManagement/ChallengeHomePage";

    export default {
        name: "ChallengeManagement",
        components: {
            ChallengeHomePage,
        },
        data() {
            return {
                challengeTabs: [
                    {
                        id: 1,
                        name: "Unpublished",
                        path: "/iadmin/challengeManagement/challengeHomePage",
                    },
                    {
                        id: 2,
                        name: "Published",
                        path: "/iadmin/challengeManagement/challengeHomePage",
                    },
                    {
                        id: 3,
                        name: "Expired",
                        path: "/iadmin/challengeManagement/challengeHomePage",
                    },

                ],
                selectedChallengeTab: "Unpublished",
            };
        },
        methods: {

        },
    };
</script>

<style scoped>

    .v-window__container,
    .v-window-item  {
        height: 100%;
    }

</style>